module.exports = __webpack_public_path__ + "static/media/secresilk-logo.9c3c9149.png";